module.exports = __webpack_public_path__ + "static/media/fz_verifydialoglocal_pt_BR.f51515f6.png";